import { render, staticRenderFns } from "./RichMenuCustomerList.vue?vue&type=template&id=01ede257&"
import script from "./RichMenuCustomerList.vue?vue&type=script&lang=js&"
export * from "./RichMenuCustomerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports